import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_jjjtg8q5tq: FaireBrandEntity = {
  token: "b_jjjtg8q5tq",
  type: "brand",
  name: "Pixie Candle Studio",
  avatarUrl:
    "https://cdn.faire.com/fastly/a5b0c5f9a4d8eb52143c20a2571ae8bd1c8764bc7a53daa315e3f08c7f738b5d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a1bf1884b3818f69f4f648afe5742ded0cc3eab9290addb6bc88ebae4aec518a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a5b0c5f9a4d8eb52143c20a2571ae8bd1c8764bc7a53daa315e3f08c7f738b5d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a1bf1884b3818f69f4f648afe5742ded0cc3eab9290addb6bc88ebae4aec518a.jpeg",
  location: "Thousand Oaks, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 16,
  isInsider: true,
  description:
    "Pixie Candle Studio specializes in  handmade candles inspired by nature and are non-toxic. Our Pixie Promise: No Phthalates, No Parabens, No Known Carcinogens, No DNA Mutagens, No Reproductive Toxins, No Organ Toxins\n\nWho we are.....\nWhat’s your earliest memory of fragrance?\nScent and memory are so intimately related. My earliest childhood memories are playing in the fragrant orange orchards of the Ojai valley. The smell of those blossoms still holds a special place in my heart, conjuring memories in my grandfather’s orchard, us together squeezing fresh orange juice from the sun-ripened fruit. Ojai, CA is a magical place to grow up, so when I first considered the brand and scents for my new candle venture, all those rich childhood memories came rushing back. Pixie Candle Studio was born. The Pixie is a very special tangerine that grows almost exclusively in Ojai. \n\nGive Back......\nAt Pixie Candle Studio we value the importance of nature and having free and open space for both humans and animals to enjoy. We are proud to partner with Ojai Valley Land Conservancy by donating 5% of our profits from our Ojai Collection. \n\nYou have so many choices when it comes to purchasing candles. We appreciate you supporting our small family business. \n\nWith gratitude-\n\nHeather",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:44.748Z",
    importedBy: "entity-db-cli",
  },
};
